import { TokenExplorerView } from "@/components/explorer/TokenExplorerView";
import { PageHero } from "@/components/ui/PageHero";

/** In-SPA USDM ledger explorer — AppShell DeFi glass (not Agent chrome). */
export default function ExploreUsdmPage() {
	return (
		<div className="pb-16">
			<PageHero
				eyebrow="Explorer"
				title="USDM Explorer"
				subtitle="On-chain Motoko Dollar ledger — supply, fee, principal balance, and recent index transactions."
			/>
			<div className="container mx-auto px-4">
				<TokenExplorerView token="USDM" title="Motoko Dollar" />
			</div>
		</div>
	);
}
